// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"43342620cc8189fe836c","655":"69a498ac90c11cb920ea"}[chunkId] + ".js";
};